// Resolves relative src=/href= URLs (e.g. "images/1.png" or
// "/images/1.png") into absolute ones, using `baseUrl` — the URL of the
// document itself — as the resolution base. Mirrors
// authoring-tool-backend's resolveRelativeUrls (src/documents/conversion.ts).
export function resolveRelativeUrls(html: string, baseUrl: string): string {
  return html.replace(
    /\b(src|href)="([^"]*)"/g,
    (match, attr: string, value: string) => {
      if (value === '' || /^(https?:|data:|mailto:|tel:|#)/i.test(value)) {
        return match
      }
      try {
        return `${attr}="${new URL(value, baseUrl).toString()}"`
      } catch {
        return match
      }
    },
  )
}
